import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { HandlingUnitMaterials, HandlingUnitMaterialsInitialState } from './handling-unit-materials.actions';
import { HandlingUnitMaterialsState, HandlingUnitMaterialsStateModel } from './handling-unit-materials.state';
import { HandlingUnitMaterial, HandlingUnitMaterialSearchCriteria } from '../../../models';
import { ListQueryParam } from '../../../../../../common/constants/list-query-param.constant';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../../../catalog-search-criteria';
import { AutomotiveAftermarketSearchCriteria } from '../../../../monitoring/automotive-aftermarket';
import { take } from 'rxjs/operators';
import { MonitoringFilterNameDictionary } from '../../../../../models';

@Injectable({ providedIn: 'root' })
export class HandlingUnitMaterialsFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<HandlingUnitMaterialsStateModel> = this.store.select(HandlingUnitMaterialsState.getState);
  items$: Observable<HandlingUnitMaterial[]> = this.store.select(HandlingUnitMaterialsState.getItems);
  loaded$: Observable<boolean> = this.store.select(HandlingUnitMaterialsState.getLoaded);

  handlingUnitNumber: string;
  deliveryNoteNumber: string;

  constructor(private store: Store, private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade) {}

  loadAll(initialFetch: boolean = true, filterFormSearchCriteria?: HandlingUnitMaterialSearchCriteria): void {
    this.catalogSearchCriteriaFacade
      .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.AutomotiveAftermarket)
      .pipe(take(1))
      .subscribe((catalogSearchCriteria: AutomotiveAftermarketSearchCriteria) => {
        const deliveryNoteNumber = this.deliveryNoteNumber;
        const handlingUnitNumber = this.handlingUnitNumber;
        const searchCriteria = initialFetch
          ? new HandlingUnitMaterialSearchCriteria({
              [ListQueryParam.BoschMaterialNumbers]:
                catalogSearchCriteria[MonitoringFilterNameDictionary.BoschMaterialNumbers],
              [ListQueryParam.CustomerMaterialNumbers]:
                catalogSearchCriteria[MonitoringFilterNameDictionary.CustomerMaterialNumbers],
              [ListQueryParam.BoschOrderNumbers]:
                catalogSearchCriteria[MonitoringFilterNameDictionary.BoschOrderNumbers],
              [ListQueryParam.CustomerOrderNumbers]:
                catalogSearchCriteria[MonitoringFilterNameDictionary.CustomerOrderNumbers],
            })
          : filterFormSearchCriteria;
        this.store.dispatch(
          new HandlingUnitMaterials({
            deliveryNoteNumber,
            handlingUnitNumber,
            searchCriteria,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new HandlingUnitMaterialsInitialState());
  }
}
